export default __webpack_public_path__ + "images/assets/3007b9e3dff1c08dd079ec33bcbb0883.svg";